import { FreeSoloAutocompleteFromViewFormField } from "@duosoftbg/nacid-components";

const ARUniFreeSoloAutocompleteField = ({ labelCode, fieldName, autocompleteFn, required = false }) => {
  return (
    <FreeSoloAutocompleteFromViewFormField
      fieldName={fieldName}
      autocompleteFn={autocompleteFn}
      labelCode={labelCode}
      inputMinSearchLength={2}
      required={required}
    />
  );
};
export default ARUniFreeSoloAutocompleteField;
